/* O'Neill PLP — interactivity (filter pills, swatches, wishlist, live viewer) */
(function () {
  'use strict';

  // Nav scrolled state (only if a #nav exists in the theme)
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 80) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    });
  }

  // Filter pill toggle — filters product cards by data-cat (matches product tags)
  document.querySelectorAll('.filter-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      document.querySelectorAll('.filter-pill').forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
      var cat = pill.dataset.cat;
      document.querySelectorAll('.product-card').forEach(function (card) {
        if (!cat || cat === 'all' || cat === 'more') {
          card.style.display = '';
        } else {
          var cats = (card.dataset.cat || '').split(/\s+/);
          card.style.display = cats.indexOf(cat) !== -1 ? '' : 'none';
        }
      });
    });
  });

  // Wishlist heart
  document.querySelectorAll('.product-fav').forEach(function (fav) {
    fav.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      fav.classList.toggle('active');
    });
  });

  // Color swatch swap
  document.querySelectorAll('.product-swatches').forEach(function (group) {
    group.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
      });
    });
  });

  // Info-icon tooltip — click/tap to toggle, click outside to close
  document.addEventListener('click', function (e) {
    var tip = e.target.closest('.info-tip');
    if (tip) {
      e.preventDefault();
      e.stopPropagation();
      var wasOpen = tip.classList.contains('info-tip--open');
      document.querySelectorAll('.info-tip--open').forEach(function (t) { t.classList.remove('info-tip--open'); });
      if (!wasOpen) tip.classList.add('info-tip--open');
    } else {
      document.querySelectorAll('.info-tip--open').forEach(function (t) { t.classList.remove('info-tip--open'); });
    }
  });

  // Quick-add → POST to /cart/add.js  (event delegation — works regardless of section render timing)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-quickadd');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.dataset.busy = '1';
    var label = btn.querySelector('.quickadd-label');
    var originalLabel = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        // Tell the parent theme to refresh its cart drawer / count
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: variantId } }));
        // Refresh cart count badge if the theme uses standard selectors
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, .cart-counter, #CartCount').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
        setTimeout(function () {
          if (label) label.textContent = originalLabel;
          btn.dataset.busy = '';
        }, 1800);
      })
      .catch(function () {
        if (label) label.textContent = 'Try again';
        setTimeout(function () {
          if (label) label.textContent = originalLabel;
          btn.dataset.busy = '';
        }, 2200);
      });
  });

  // Live viewer flicker
  setInterval(function () {
    var span = document.querySelector('.live-views strong');
    if (!span) return;
    var cur = parseInt(span.textContent, 10) || 150;
    var next = cur + Math.floor(Math.random() * 7 - 3);
    span.textContent = Math.max(110, Math.min(220, next)) + ' people';
  }, 4000);
})();
